/**
 * Utility function to copy text to clipboard with fallback support
 * Works in both HTTPS and HTTP environments
 */
export const copyToClipboard = async (text: string, label: string = 'Text'): Promise<void> => {
  if (!text) return;
  
  try {
    // Try modern clipboard API first (requires HTTPS)
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      alert(`${label} copied to clipboard!`);
      return;
    }
    
    // Fallback for older browsers or non-HTTPS environments
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        alert(`${label} copied to clipboard!`);
      } else {
        throw new Error('Copy command failed');
      }
    } catch (err) {
      console.error('Fallback copy failed:', err);
      // Show the text so user can copy manually
      prompt(`Copy this ${label}:`, text);
    } finally {
      document.body.removeChild(textArea);
    }
  } catch (err) {
    console.error('Copy to clipboard failed:', err);
    // Last resort - show in prompt dialog
    prompt(`Copy this ${label}:`, text);
  }
};

/**
 * Check if clipboard API is available
 */
export const isClipboardAvailable = (): boolean => {
  return !!(navigator.clipboard && navigator.clipboard.writeText);
};